var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _vm.state.preview
        ? _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.state.preview.Subject)),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("w-card-content", { style: { height: "100%" } }, [
        _c("iframe", {
          ref: "frame",
          staticClass: "frame",
          attrs: { srcdoc: _vm.previewText, src: "about:blank" },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }